var _g, _g2, _g3, _g4, _g5, _g6, _style, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Final-white",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 35 35",
    style: {
      whiteSpace: "pre"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "Mask-1",
    style: {
      maskType: "alpha"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right_mask-2",
    transform: "translate(96.875,54.854) scale(4.81481,4.81481) translate(-26.531,-13.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-2",
    opacity: 1,
    transform: "translate(26.531,13.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-2",
    fill: "#0de7b2",
    d: "M2.469,0.246C2.469,0.246,2.469,-4.758,2.469,-4.758C2.469,-4.758,-1.445,-2.149,-1.445,-2.149C-2.085,-1.723,-2.469,-1.01,-2.469,-0.247C-2.469,-0.247,-2.469,4.758,-2.469,4.758C-2.469,4.758,1.445,2.149,1.445,2.149C2.085,1.722,2.469,1.01,2.469,0.246Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-2",
    style: {
      maskType: "alpha"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Right_mask",
    transform: "translate(90.226,53.465) scale(4.27984,4.81481) translate(-26.531,-13.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-4",
    opacity: 1,
    transform: "translate(26.531,13.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-4",
    fill: "#0de7b2",
    d: "M2.469,0.246C2.469,0.246,2.469,-4.758,2.469,-4.758C2.469,-4.758,-1.445,-2.149,-1.445,-2.149C-2.085,-1.723,-2.469,-1.01,-2.469,-0.247C-2.469,-0.247,-2.469,4.758,-2.469,4.758C-2.469,4.758,1.445,2.149,1.445,2.149C2.085,1.722,2.469,1.01,2.469,0.246Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-3",
    style: {
      maskType: "alpha"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Left_mask-2",
    transform: "translate(7.737,54.844) scale(4.81481,4.81481) translate(-2.464,-13.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-2",
    opacity: 1,
    transform: "translate(2.464,13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-6",
    fill: "#0de7b2",
    d: "M2.464,4.755C2.464,4.755,2.464,-0.25,2.464,-0.25C2.464,-1.013,2.08,-1.727,1.44,-2.153C1.44,-2.153,-2.464,-4.755,-2.464,-4.755C-2.464,-4.755,-2.464,0.25,-2.464,0.25C-2.464,1.013,-2.08,1.726,-1.44,2.152C-1.44,2.152,2.464,4.755,2.464,4.755Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-4",
    style: {
      maskType: "alpha"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Left_mask",
    transform: "translate(10.992,53.455) scale(4.27984,4.81481) translate(-2.464,-13.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-4",
    opacity: 1,
    transform: "translate(2.464,13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-8",
    fill: "#0de7b2",
    d: "M2.464,4.755C2.464,4.755,2.464,-0.25,2.464,-0.25C2.464,-1.013,2.08,-1.727,1.44,-2.153C1.44,-2.153,-2.464,-4.755,-2.464,-4.755C-2.464,-4.755,-2.464,0.25,-2.464,0.25C-2.464,1.013,-2.08,1.726,-1.44,2.152C-1.44,2.152,2.464,4.755,2.464,4.755Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-5",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-2_mask-2",
    transform: "translate(89.815,45.37) scale(3.7037,3.7037) translate(-9.625,2.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1",
    opacity: 1,
    transform: "translate(0.125,0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-10",
    fill: "none",
    d: "M16.063,-12.438C16.063,-12.438,3.688,-3.688,3.688,-3.688C3.688,-3.688,3.813,8.656,3.813,8.656",
    stroke: "#e70d0d",
    strokeOpacity: 1,
    strokeWidth: 7,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: 27.5006,
    strokeDashoffset: -11.0002,
    style: {
      animation: "4s linear infinite both Path-1-10_do"
    }
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-6",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-2_mask",
    transform: "translate(83.951,43.981) scale(3.29218,3.7037) translate(-9.625,2.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1-2",
    opacity: 1,
    transform: "translate(0.125,0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-12",
    fill: "none",
    d: "M16.063,-12.438C16.063,-12.438,3.688,-3.688,3.688,-3.688C3.688,-3.688,3.813,8.656,3.813,8.656",
    stroke: "#e70d0d",
    strokeOpacity: 1,
    strokeWidth: 7,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: 27.5006,
    strokeDashoffset: 0,
    style: {
      animation: "4s linear infinite both Path-1-12_do"
    }
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-7",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-2_mask-2",
    transform: "translate(15.509,45.37) scale(-3.7037,3.7037) translate(-9.625,2.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1-3",
    opacity: 1,
    transform: "translate(0.125,0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-14",
    fill: "none",
    d: "M16.063,-12.438C16.063,-12.438,3.688,-3.688,3.688,-3.688C3.688,-3.688,3.813,8.656,3.813,8.656",
    stroke: "#e70d0d",
    strokeOpacity: 1,
    strokeWidth: 7,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: 27.5006,
    strokeDashoffset: -11.0002,
    style: {
      animation: "4s linear infinite both Path-1-14_do"
    }
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-8",
    style: {
      maskType: "alpha"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-2_mask",
    transform: "translate(17.901,43.981) scale(-3.29218,3.7037) translate(-9.625,2.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1-4",
    opacity: 1,
    transform: "translate(0.125,0.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-16",
    fill: "none",
    d: "M16.063,-12.438C16.063,-12.438,3.688,-3.688,3.688,-3.688C3.688,-3.688,3.813,8.656,3.813,8.656",
    stroke: "#e70d0d",
    strokeOpacity: 1,
    strokeWidth: 7,
    strokeMiterlimit: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: 27.5006,
    strokeDashoffset: 0,
    style: {
      animation: "4s linear infinite both Path-1-16_do"
    }
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-9",
    style: {
      maskType: "alpha"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Niz_mask-2",
    transform: "translate(52.315,86.881) scale(5.18519,5.18519) translate(-14.5,-23.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-2",
    opacity: 1,
    transform: "translate(14.5,23.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-18",
    fill: "#0de7b2",
    d: "M0.82,-2.525C0.82,-2.525,6.38,2.973,6.38,2.973C6.38,2.973,-6.38,2.973,-6.38,2.973C-6.38,2.973,-0.82,-2.525,-0.82,-2.525C-0.367,-2.973,0.367,-2.973,0.82,-2.525Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "Mask-10",
    style: {
      maskType: "alpha"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Niz_mask",
    transform: "translate(50.617,87.25) scale(4.60905,5.18519) translate(-14.5,-23.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-4",
    opacity: 1,
    transform: "translate(14.5,23.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-20",
    fill: "#0de7b2",
    d: "M0.82,-2.525C0.82,-2.525,6.38,2.973,6.38,2.973C6.38,2.973,-6.38,2.973,-6.38,2.973C-6.38,2.973,-0.82,-2.525,-0.82,-2.525C-0.367,-2.973,0.367,-2.973,0.82,-2.525Z",
    fillOpacity: 1,
    fillRule: "nonzero",
    opacity: 1
  })))))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        @keyframes a0_t {\n            0% {\n                transform: translate(17.25px, 16.875px) rotate(360deg);\n            }\n\n            54.5% {\n                transform: translate(17.25px, 16.875px) rotate(360deg);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.254, 1);\n            }\n\n            77.425% {\n                transform: translate(17.25px, 16.875px) rotate(720deg);\n            }\n\n            100% {\n                transform: translate(17.25px, 16.875px) rotate(720deg);\n            }\n        }\n\n        @keyframes Circle-3_t {\n            0% {\n                transform: scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n\n            67.5% {\n                transform: scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n\n            71% {\n                transform: scale(0.67, 0.67) translate(0.25px, 0.125px);\n            }\n\n            100% {\n                transform: scale(0.67, 0.67) translate(0.25px, 0.125px);\n            }\n        }\n\n        @keyframes Circle-3_v {\n            0% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            54.5% {\n                visibility: visible;\n                animation-timing-function: steps(1);\n            }\n\n            79.5% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            100% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n        }\n\n        @keyframes Ellipse-Path-1_do {\n            0% {\n                stroke-dashoffset: -108.171px;\n            }\n\n            54.5% {\n                stroke-dashoffset: -108.171px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            67% {\n                stroke-dashoffset: -76.4848px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            79.5% {\n                stroke-dashoffset: -107.079px;\n            }\n\n            100% {\n                stroke-dashoffset: -107.079px;\n            }\n        }\n\n        @keyframes Circle-2_t {\n            0% {\n                transform: translate(17.25px, 16.875px) rotate(360deg) scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n\n            29.5% {\n                transform: translate(17.25px, 16.875px) rotate(360deg) scale(0.8, 0.8) translate(0.25px, 0.125px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.254, 1);\n            }\n\n            52.425% {\n                transform: translate(17.25px, 16.875px) rotate(720deg) scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n\n            100% {\n                transform: translate(17.25px, 16.875px) rotate(720deg) scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n        }\n\n        @keyframes Circle-2_v {\n            0% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            29.5% {\n                visibility: visible;\n                animation-timing-function: steps(1);\n            }\n\n            54.5% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            100% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n        }\n\n        @keyframes Ellipse-Path-1-2_do {\n            0% {\n                stroke-dashoffset: -108.171px;\n            }\n\n            29.5% {\n                stroke-dashoffset: -108.171px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            42% {\n                stroke-dashoffset: -76.4848px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            54.5% {\n                stroke-dashoffset: -107.079px;\n            }\n\n            100% {\n                stroke-dashoffset: -107.079px;\n            }\n        }\n\n        @keyframes a1_t {\n            0% {\n                transform: translate(17.25px, 16.875px) rotate(360deg);\n            }\n\n            4.5% {\n                transform: translate(17.25px, 16.875px) rotate(360deg);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.254, 1);\n            }\n\n            27.425% {\n                transform: translate(17.25px, 16.875px) rotate(720deg);\n            }\n\n            100% {\n                transform: translate(17.25px, 16.875px) rotate(720deg);\n            }\n        }\n\n        @keyframes Circle-1_t {\n            0% {\n                transform: scale(0.67, 0.67) translate(0.25px, 0.125px);\n            }\n\n            5.5% {\n                transform: scale(0.67, 0.67) translate(0.25px, 0.125px);\n            }\n\n            9% {\n                transform: scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n\n            100% {\n                transform: scale(0.8, 0.8) translate(0.25px, 0.125px);\n            }\n        }\n\n        @keyframes Circle-1_v {\n            0% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            4.5% {\n                visibility: visible;\n                animation-timing-function: steps(1);\n            }\n\n            29.5% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n\n            100% {\n                visibility: hidden;\n                animation-timing-function: steps(1);\n            }\n        }\n\n        @keyframes Ellipse-Path-1-3_do {\n            0% {\n                stroke-dashoffset: -108.171px;\n            }\n\n            4.5% {\n                stroke-dashoffset: -108.171px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            17% {\n                stroke-dashoffset: -76.4848px;\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            29.5% {\n                stroke-dashoffset: -107.079px;\n            }\n\n            100% {\n                stroke-dashoffset: -107.079px;\n            }\n        }\n\n        @keyframes Right-eye-2_t {\n            0% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            72% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            77.5% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Right-3_t {\n            0% {\n                transform: translate(79.977px, 37.956px) scale(2.96296, 2.96296) translate(-26.531px, -13.936px);\n            }\n\n            74.5% {\n                transform: translate(79.977px, 37.956px) scale(2.96296, 2.96296) translate(-26.531px, -13.936px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            82% {\n                transform: translate(96.875px, 54.854px) scale(3.7037, 3.7037) translate(-26.531px, -13.936px);\n            }\n\n            100% {\n                transform: translate(96.875px, 54.854px) scale(3.7037, 3.7037) translate(-26.531px, -13.936px);\n            }\n        }\n\n        @keyframes Right-eye-1_t {\n            0% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n            }\n\n            2% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            8% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Right_t {\n            0% {\n                transform: scale(3.29218, 3.7037) translate(-26.531px, -13.936px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            7.5% {\n                transform: scale(0, 0) translate(-26.531px, -13.936px);\n            }\n\n            100% {\n                transform: scale(0, 0) translate(-26.531px, -13.936px);\n            }\n        }\n\n        @keyframes Right_mo {\n            0% {\n                offset-distance: 0%;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            7.5% {\n                offset-distance: 100%;\n            }\n\n            100% {\n                offset-distance: 100%;\n            }\n        }\n\n        @keyframes Left-eye-2_t {\n            0% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            71.5% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            77.5% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Left-4_t {\n            0% {\n                transform: translate(23.94px, 38.64px) scale(2.96296, 2.96296) translate(-2.464px, -13.933px);\n            }\n\n            74.5% {\n                transform: translate(23.94px, 38.64px) scale(2.96296, 2.96296) translate(-2.464px, -13.933px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            82% {\n                transform: translate(7.737px, 54.844px) scale(3.7037, 3.7037) translate(-2.464px, -13.933px);\n            }\n\n            100% {\n                transform: translate(7.737px, 54.844px) scale(3.7037, 3.7037) translate(-2.464px, -13.933px);\n            }\n        }\n\n        @keyframes Left-eye-1_t {\n            0% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n            }\n\n            2% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            8% {\n                transform: translate(16.813px, 17px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.813px, 17px) scale(0, 0) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Left_t {\n            0% {\n                transform: scale(3.29218, 3.7037) translate(-2.464px, -13.933px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            7.5% {\n                transform: scale(0, 0) translate(-2.464px, -13.933px);\n            }\n\n            100% {\n                transform: scale(0, 0) translate(-2.464px, -13.933px);\n            }\n        }\n\n        @keyframes Left_mo {\n            0% {\n                offset-distance: 0%;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            7.5% {\n                offset-distance: 100%;\n            }\n\n            100% {\n                offset-distance: 100%;\n            }\n        }\n\n        @keyframes Right-2_t {\n            0% {\n                transform: translate(16.375px, 17.625px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            71.5% {\n                transform: translate(16.375px, 17.625px) scale(0, 0) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            77.5% {\n                transform: translate(16.375px, 17.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.375px, 17.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Path-1-10_do {\n            0% {\n                stroke-dashoffset: -11.0002px;\n            }\n\n            72% {\n                stroke-dashoffset: -11.0002px;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            82% {\n                stroke-dashoffset: 0px;\n            }\n\n            100% {\n                stroke-dashoffset: 0px;\n            }\n        }\n\n        @keyframes Right-1_t {\n            0% {\n                transform: translate(16.813237px, 17.93755px) scale(0.30375, 0.27) translate(-50px, -50px);\n            }\n\n            2% {\n                transform: translate(16.813237px, 17.93755px) scale(0.30375, 0.27) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            8% {\n                transform: translate(16.813237px, 17.93755px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.813237px, 17.93755px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Path-1-12_do {\n            0% {\n                stroke-dashoffset: 0px;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            10% {\n                stroke-dashoffset: -27.5006px;\n            }\n\n            100% {\n                stroke-dashoffset: -27.5006px;\n            }\n        }\n\n        @keyframes Left-2_t {\n            0% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            71.5% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            77.5% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Path-1-14_do {\n            0% {\n                stroke-dashoffset: -11.0002px;\n            }\n\n            72% {\n                stroke-dashoffset: -11.0002px;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            82% {\n                stroke-dashoffset: 0px;\n            }\n\n            100% {\n                stroke-dashoffset: 0px;\n            }\n        }\n\n        @keyframes Left-1_t {\n            0% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n            }\n\n            2% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            8% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Path-1-16_do {\n            0% {\n                stroke-dashoffset: 0px;\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            10% {\n                stroke-dashoffset: -27.5006px;\n            }\n\n            100% {\n                stroke-dashoffset: -27.5006px;\n            }\n        }\n\n        @keyframes Bottom-2_t {\n            0% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n            }\n\n            71.5% {\n                transform: translate(16.375px, 16.625px) scale(0, 0) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            77.5% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.375px, 16.625px) scale(0.27, 0.27) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Niz-2_t {\n            0% {\n                transform: translate(52.315px, 60.955px) scale(2.96296, 2.96296) translate(-14.5px, -23.083px);\n            }\n\n            73.5% {\n                transform: translate(52.315px, 60.955px) scale(2.96296, 2.96296) translate(-14.5px, -23.083px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            81% {\n                transform: translate(52.315px, 88.733px) scale(3.7037, 3.7037) translate(-14.5px, -23.083px);\n            }\n\n            100% {\n                transform: translate(52.315px, 88.733px) scale(3.7037, 3.7037) translate(-14.5px, -23.083px);\n            }\n        }\n\n        @keyframes Bottom-1_t {\n            0% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n            }\n\n            2% {\n                transform: translate(16.813px, 17px) scale(0.30375, 0.27) translate(-50px, -50px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            8% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n\n            100% {\n                transform: translate(16.813px, 17px) scale(0.2, 0.17778) translate(-50px, -50px);\n            }\n        }\n\n        @keyframes Niz_t {\n            0% {\n                transform: translate(50.617px, 87.344px) scale(3.29218, 3.7037) translate(-14.5px, -23.083px);\n            }\n\n            6.5% {\n                transform: translate(50.617px, 87.344px) scale(3.29218, 3.7037) translate(-14.5px, -23.083px);\n                animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);\n            }\n\n            14% {\n                transform: translate(50.617px, 59.566px) scale(0, 0) translate(-14.5px, -23.083px);\n            }\n\n            100% {\n                transform: translate(50.617px, 59.566px) scale(0, 0) translate(-14.5px, -23.083px);\n            }\n        }\n\n        @keyframes Group-6-2_o {\n            0% {\n                opacity: 0;\n            }\n\n            73.5% {\n                opacity: 0;\n            }\n\n            74% {\n                opacity: 1;\n            }\n\n            100% {\n                opacity: 1;\n            }\n        }\n\n        @keyframes Path-1-21_d {\n            0% {\n                d: path('M-5.751,0.858C-5.751,0.858,-6.236,-0.666,-6.236,-0.666C-6.236,-0.666,-2.742,-2.211,-2.742,-2.211C-2.742,-2.211,-2.067,-0.28,-2.067,-0.28C-2.459,-0.019,-5.359,1.119,-5.751,0.858Z');\n            }\n\n            73.5% {\n                d: path('M-5.751,0.858C-5.751,0.858,-6.236,-0.666,-6.236,-0.666C-6.236,-0.666,-2.742,-2.211,-2.742,-2.211C-2.742,-2.211,-2.067,-0.28,-2.067,-0.28C-2.459,-0.019,-5.359,1.119,-5.751,0.858Z');\n                animation-timing-function: cubic-bezier(0.33, 0, 0.25, 1);\n            }\n\n            79% {\n                d: path('M-0.649,2.767C-0.649,2.767,-9.346,-3.028,-9.346,-3.028C-9.346,-3.028,9.346,-3.028,9.346,-3.028C9.346,-3.028,0.648,2.767,0.648,2.767C0.256,3.028,-0.257,3.028,-0.649,2.767Z');\n            }\n\n            100% {\n                d: path('M-0.649,2.767C-0.649,2.767,-9.346,-3.028,-9.346,-3.028C-9.346,-3.028,9.346,-3.028,9.346,-3.028C9.346,-3.028,0.648,2.767,0.648,2.767C0.256,3.028,-0.257,3.028,-0.649,2.767Z');\n            }\n        }\n\n        @keyframes Group-6-3_o {\n            0% {\n                opacity: 1;\n            }\n\n            7% {\n                opacity: 1;\n            }\n\n            7.5% {\n                opacity: 0;\n            }\n\n            100% {\n                opacity: 0;\n            }\n        }\n\n        @keyframes Path-1-22_d {\n            0% {\n                d: path('M-0.649,2.767C-0.649,2.767,-9.346,-3.028,-9.346,-3.028C-9.346,-3.028,9.346,-3.028,9.346,-3.028C9.346,-3.028,0.648,2.767,0.648,2.767C0.256,3.028,-0.257,3.028,-0.649,2.767Z');\n            }\n\n            1% {\n                d: path('M-0.649,2.767C-0.649,2.767,-9.346,-3.028,-9.346,-3.028C-9.346,-3.028,9.346,-3.028,9.346,-3.028C9.346,-3.028,0.648,2.767,0.648,2.767C0.256,3.028,-0.257,3.028,-0.649,2.767Z');\n                animation-timing-function: cubic-bezier(0.333, 0, 0.667, 1);\n            }\n\n            7% {\n                d: path('M0.476,-1.921C0.476,-1.921,0.592,-3.684,0.592,-3.684C0.592,-3.684,5.065,-2.809,5.065,-2.809C5.065,-2.809,3.867,-1.045,3.867,-1.045C3.475,-0.784,0.868,-1.66,0.476,-1.921Z');\n            }\n\n            100% {\n                d: path('M0.476,-1.921C0.476,-1.921,0.592,-3.684,0.592,-3.684C0.592,-3.684,5.065,-2.809,5.065,-2.809C5.065,-2.809,3.867,-1.045,3.867,-1.045C3.475,-0.784,0.868,-1.66,0.476,-1.921Z');\n            }\n        }\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "Circle-3",
    style: {
      animation: "4s linear infinite both a0_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    transform: "translate(17.25,16.875) rotate(360) scale(0.8,0.8) translate(0.25,0.125)",
    style: {
      animation: "4s linear infinite both Circle-3_t, 4s linear infinite forwards Circle-3_v"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1",
    opacity: 1,
    transform: "translate(-0.25,-0.125) scale(0.98575,0.98575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-Path-1",
    fill: "none",
    d: "M0,-17.5C9.66498,-17.5,17.5,-9.66498,17.5,0C17.5,9.66498,9.66498,17.5,0,17.5C-9.66498,17.5,-17.5,9.66498,-17.5,0C-17.5,-9.66498,-9.66498,-17.5,0,-17.5Z",
    stroke: "#ffffff",
    strokeOpacity: 1,
    strokeWidth: 2.3,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: 109.264,
    strokeDashoffset: -108.171,
    style: {
      animation: "4s linear infinite both Ellipse-Path-1_do"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Circle-2",
    visibility: "hidden",
    transform: "translate(17.25,16.875) rotate(360) scale(0.8,0.8) translate(0.25,0.125)",
    style: {
      animation: "4s linear infinite both Circle-2_t, 4s linear infinite forwards Circle-2_v"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1-2",
    opacity: 1,
    transform: "translate(-0.25,-0.125) scale(0.98575,0.98575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-Path-1-2",
    fill: "none",
    d: "M0,-17.5C9.66498,-17.5,17.5,-9.66498,17.5,0C17.5,9.66498,9.66498,17.5,0,17.5C-9.66498,17.5,-17.5,9.66498,-17.5,0C-17.5,-9.66498,-9.66498,-17.5,0,-17.5Z",
    stroke: "#ffffff",
    strokeOpacity: 1,
    strokeWidth: 2.3,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: 109.264,
    strokeDashoffset: -108.171,
    style: {
      animation: "4s linear infinite both Ellipse-Path-1-2_do"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Circle-1",
    style: {
      animation: "4s linear infinite both a1_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    transform: "translate(17.25,16.875) rotate(360) scale(0.67,0.67) translate(0.25,0.125)",
    style: {
      animation: "4s linear infinite both Circle-1_t, 4s linear infinite forwards Circle-1_v"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse-1-3",
    opacity: 1,
    transform: "translate(-0.25,-0.125) scale(0.98575,0.98575)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse-Path-1-3",
    fill: "none",
    d: "M0,-17.5C9.66498,-17.5,17.5,-9.66498,17.5,0C17.5,9.66498,9.66498,17.5,0,17.5C-9.66498,17.5,-17.5,9.66498,-17.5,0C-17.5,-9.66498,-9.66498,-17.5,0,-17.5Z",
    stroke: "#ffffff",
    strokeOpacity: 1,
    strokeWidth: 2.3,
    strokeMiterlimit: 4,
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    strokeDasharray: 109.264,
    strokeDashoffset: -108.171,
    style: {
      animation: "4s linear infinite both Ellipse-Path-1-3_do"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Right-eye-2",
    transform: "translate(16.375,16.625) scale(0,0) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Right-eye-2_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-3",
    transform: "translate(79.977,37.956) scale(2.96296,2.96296) translate(-26.531,-13.936)",
    style: {
      animation: "4s linear infinite both Right-3_t"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    opacity: 1,
    transform: "translate(26.531,13.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1",
    fill: "#ffffff",
    d: "M2.469,0.246C2.469,0.246,2.469,-4.758,2.469,-4.758C2.469,-4.758,-1.445,-2.149,-1.445,-2.149C-2.085,-1.723,-2.469,-1.01,-2.469,-0.247C-2.469,-0.247,-2.469,4.758,-2.469,4.758C-2.469,4.758,1.445,2.149,1.445,2.149C2.085,1.722,2.469,1.01,2.469,0.246Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Right-eye-1",
    transform: "translate(16.813,17) scale(0.30375,0.27) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Right-eye-1_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    style: {
      transform: "scale(3.29218,3.7037) translate(-26.531px,-13.936px)",
      animation: "4s linear infinite both Right_t, 4s linear infinite both Right_mo",
      offsetPath: "path('M90.226,53.465C90.226,53.465,75.206,36.567,75.206,36.567L75.206,36.567')",
      offsetRotate: "0deg"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group-5-3",
    opacity: 1,
    transform: "translate(26.531,13.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-3",
    fill: "#ffffff",
    d: "M2.469,0.246C2.469,0.246,2.469,-4.758,2.469,-4.758C2.469,-4.758,-1.445,-2.149,-1.445,-2.149C-2.085,-1.723,-2.469,-1.01,-2.469,-0.247C-2.469,-0.247,-2.469,4.758,-2.469,4.758C-2.469,4.758,1.445,2.149,1.445,2.149C2.085,1.722,2.469,1.01,2.469,0.246Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Left-eye-2",
    transform: "translate(16.375,16.625) scale(0,0) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Left-eye-2_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-4",
    transform: "translate(23.94,38.64) scale(2.96296,2.96296) translate(-2.464,-13.933)",
    style: {
      animation: "4s linear infinite both Left-4_t"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    opacity: 1,
    transform: "translate(2.464,13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-5",
    fill: "#ffffff",
    d: "M2.464,4.755C2.464,4.755,2.464,-0.25,2.464,-0.25C2.464,-1.013,2.08,-1.727,1.44,-2.153C1.44,-2.153,-2.464,-4.755,-2.464,-4.755C-2.464,-4.755,-2.464,0.25,-2.464,0.25C-2.464,1.013,-2.08,1.726,-1.44,2.152C-1.44,2.152,2.464,4.755,2.464,4.755Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Left-eye-1",
    transform: "translate(16.813,17) scale(0.30375,0.27) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Left-eye-1_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left",
    style: {
      transform: "scale(3.29218,3.7037) translate(-2.464px,-13.933px)",
      animation: "4s linear infinite both Left_t, 4s linear infinite both Left_mo",
      offsetPath: "path('M10.992,53.455C10.992,53.455,25.395,37.251,25.395,37.251L25.395,37.251')",
      offsetRotate: "0deg"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3-3",
    opacity: 1,
    transform: "translate(2.464,13.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-7",
    fill: "#ffffff",
    d: "M2.464,4.755C2.464,4.755,2.464,-0.25,2.464,-0.25C2.464,-1.013,2.08,-1.727,1.44,-2.153C1.44,-2.153,-2.464,-4.755,-2.464,-4.755C-2.464,-4.755,-2.464,0.25,-2.464,0.25C-2.464,1.013,-2.08,1.726,-1.44,2.152C-1.44,2.152,2.464,4.755,2.464,4.755Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Right-2",
    transform: "translate(16.375,17.625) scale(0,0) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Right-2_t"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-4",
    transform: "translate(52.315,51.389) scale(3.7037,3.7037) translate(-14.5,-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    opacity: 1,
    transform: "translate(22.475,10.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-9",
    fill: "#ffffff",
    d: "M6.525,-5.844C6.525,-5.844,6.525,-10.848,6.525,-10.848C6.525,-10.848,-4.862,-3.259,-4.862,-3.259C-5.901,-2.566,-6.525,-1.407,-6.525,-0.167C-6.525,-0.167,-6.525,4.736,-6.525,4.736C-6.525,5.344,-6.281,5.928,-5.846,6.358C-5.846,6.358,-1.305,10.848,-1.305,10.848C-1.305,10.848,-1.305,10.214,-1.305,10.214C-1.305,10.214,-1.307,10.214,-1.307,10.214C-1.307,10.214,-1.307,2.116,-1.307,2.116C-1.307,1.164,-0.827,0.274,-0.025,-0.26C-0.025,-0.26,5.502,-3.941,5.502,-3.941C6.142,-4.367,6.525,-5.081,6.525,-5.844Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Right-1",
    transform: "translate(16.8132,17.9376) scale(0.30375,0.27) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Right-1_t"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-2-2",
    transform: "translate(50.617,50) scale(3.29218,3.7037) translate(-14.5,-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    opacity: 1,
    transform: "translate(14.496,3.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fill: "#ffffff",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-2",
    opacity: 1,
    transform: "translate(22.475,10.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-11",
    fill: "#ffffff",
    d: "M6.525,-5.844C6.525,-5.844,6.525,-10.848,6.525,-10.848C6.525,-10.848,-4.862,-3.259,-4.862,-3.259C-5.901,-2.566,-6.525,-1.407,-6.525,-0.167C-6.525,-0.167,-6.525,4.736,-6.525,4.736C-6.525,5.344,-6.281,5.928,-5.846,6.358C-5.846,6.358,-1.305,10.848,-1.305,10.848C-1.305,10.848,-1.305,10.214,-1.305,10.214C-1.305,10.214,-1.307,10.214,-1.307,10.214C-1.307,10.214,-1.307,2.116,-1.307,2.116C-1.307,1.164,-0.827,0.274,-0.025,-0.26C-0.025,-0.26,5.502,-3.941,5.502,-3.941C6.142,-4.367,6.525,-5.081,6.525,-5.844Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Left-2",
    transform: "translate(16.375,16.625) scale(0,0) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Left-2_t"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-3",
    transform: "translate(52.315,51.389) scale(3.7037,3.7037) translate(-14.5,-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    opacity: 1,
    transform: "translate(6.525,10.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-13",
    fill: "#ffffff",
    d: "M6.525,4.736C6.525,5.344,6.28,5.928,5.845,6.358C5.845,6.358,1.305,10.849,1.305,10.849C1.305,10.849,1.305,4.478,1.305,4.478C1.305,4.478,1.298,4.473,1.298,4.473C1.298,4.473,1.298,3.542,1.298,3.542C1.298,3.542,1.305,3.547,1.305,3.547C1.305,3.547,1.305,2.116,1.305,2.116C1.305,1.164,0.825,0.275,0.024,-0.259C0.024,-0.259,-5.501,-3.941,-5.501,-3.941C-6.141,-4.367,-6.525,-5.081,-6.525,-5.844C-6.525,-5.844,-6.525,-10.849,-6.525,-10.849C-6.525,-10.849,4.862,-3.26,4.862,-3.26C5.902,-2.567,6.525,-1.408,6.525,-0.168C6.525,-0.168,6.525,4.736,6.525,4.736Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Left-1",
    transform: "translate(16.813,17) scale(0.30375,0.27) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Left-1_t"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Left-2-2",
    transform: "translate(50.617,50) scale(3.29218,3.7037) translate(-14.5,-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1-2",
    opacity: 1,
    transform: "translate(6.525,10.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-15",
    fill: "#ffffff",
    d: "M6.525,4.736C6.525,5.344,6.28,5.928,5.845,6.358C5.845,6.358,1.305,10.849,1.305,10.849C1.305,10.849,1.305,4.478,1.305,4.478C1.305,4.478,1.298,4.473,1.298,4.473C1.298,4.473,1.298,3.542,1.298,3.542C1.298,3.542,1.305,3.547,1.305,3.547C1.305,3.547,1.305,2.116,1.305,2.116C1.305,1.164,0.825,0.275,0.024,-0.259C0.024,-0.259,-5.501,-3.941,-5.501,-3.941C-6.141,-4.367,-6.525,-5.081,-6.525,-5.844C-6.525,-5.844,-6.525,-10.849,-6.525,-10.849C-6.525,-10.849,4.862,-3.26,4.862,-3.26C5.902,-2.567,6.525,-1.408,6.525,-0.168C6.525,-0.168,6.525,4.736,6.525,4.736Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Bottom-2",
    transform: "translate(16.375,16.625) scale(0,0) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Bottom-2_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Niz-2",
    transform: "translate(52.315,60.955) scale(2.96296,2.96296) translate(-14.5,-23.083)",
    style: {
      animation: "4s linear infinite both Niz-2_t"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    opacity: 1,
    transform: "translate(14.5,23.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-17",
    fill: "#ffffff",
    d: "M0.82,-2.525C0.82,-2.525,6.38,2.973,6.38,2.973C6.38,2.973,-6.38,2.973,-6.38,2.973C-6.38,2.973,-0.82,-2.525,-0.82,-2.525C-0.367,-2.973,0.367,-2.973,0.82,-2.525Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Bottom-1",
    transform: "translate(16.813,17) scale(0.30375,0.27) translate(-50,-50)",
    style: {
      animation: "4s linear infinite both Bottom-1_t"
    }
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#Mask-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Niz",
    transform: "translate(50.617,87.344) scale(3.29218,3.7037) translate(-14.5,-23.083)",
    style: {
      animation: "4s linear infinite both Niz_t"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group-4-3",
    opacity: 1,
    transform: "translate(14.5,23.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-19",
    fill: "#ffffff",
    d: "M0.82,-2.525C0.82,-2.525,6.38,2.973,6.38,2.973C6.38,2.973,-6.38,2.973,-6.38,2.973C-6.38,2.973,-0.82,-2.525,-0.82,-2.525C-0.367,-2.973,0.367,-2.973,0.82,-2.525Z",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Top-2",
    transform: "translate(16.996,6.995) translate(-14.496,-2.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-2",
    opacity: 0,
    transform: "translate(14.496,3.028)",
    style: {
      animation: "4s linear infinite both Group-6-2_o"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-21",
    fill: "#ffffff",
    d: "M-5.751,0.858C-5.751,0.858,-6.236,-0.666,-6.236,-0.666C-6.236,-0.666,-2.742,-2.211,-2.742,-2.211C-2.742,-2.211,-2.067,-0.28,-2.067,-0.28C-2.459,-0.019,-5.359,1.119,-5.751,0.858Z",
    fillOpacity: 1,
    fillRule: "nonzero",
    style: {
      animation: "4s linear infinite both Path-1-21_d"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Top-1",
    transform: "translate(16.996,6.995) translate(-14.496,-2.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-3",
    opacity: 1,
    transform: "translate(14.496,3.028)",
    style: {
      animation: "4s linear infinite both Group-6-3_o"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-1-22",
    fill: "#ffffff",
    d: "M-0.649,2.767C-0.649,2.767,-9.346,-3.028,-9.346,-3.028C-9.346,-3.028,9.346,-3.028,9.346,-3.028C9.346,-3.028,0.648,2.767,0.648,2.767C0.256,3.028,-0.257,3.028,-0.649,2.767Z",
    fillOpacity: 1,
    fillRule: "nonzero",
    style: {
      animation: "4s linear infinite both Path-1-22_d"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.cd8590cd370b586a4d8d0858a0bb237b.svg";
export { ForwardRef as ReactComponent };